module.exports = __webpack_public_path__ + "static/media/53_Print.d5d642bd.png";